import { encrypted, decrypted } from 'config/crypto';

export const setLocalStorageValue = (key, value) => localStorage.setItem(key, encrypted(value));;

export const getLocalStorageValue = (key) => localStorage.getItem(key) && decrypted(localStorage.getItem(key));

